enum HandlerStatus {
    NONE,
    RESEND,
    ABORT
}

export default HandlerStatus;